/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/jsx-no-undef */
import React, { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Popover,
  Chip,
  Grid,
  Paper,
  Dialog,
  Slide,
} from '@mui/material';
import ChangePassword from '../../../DevelopmentComp/Others/ChangePassword';
// mocks_
import logoImage from '../../../media/corporate.png';
import account from '../../../_mock/account';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AccountPopover() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    navigate('/');
    sessionStorage.clear();
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
    handleClose();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          zIndex: 1500,
          ...(open && {
            '&:before': {
              zIndex: 1500,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
            },
          }),
        }}
      >
        <Chip
          avatar={<Avatar alt="Admin" src={account.photoURL} />}
          label={sessionStorage.getItem('UserName')}
          variant="outlined"
          size="medium"
        />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
              zIndex: 25000,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5, textAlign: 'center' }}>
          <Typography variant="subtitle2" noWrap>
            {sessionStorage.getItem('UserName')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {sessionStorage.getItem('UserEmail')}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
      <Dialog open={dialogOpen} TransitionComponent={Transition} keepMounted aria-describedby="change-password-dialog">
        <ChangePassword setDialogOpen={setDialogOpen} />
      </Dialog>
    </>
  );
}
